import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import layoutExample1 from './assets/images/layout-example1.png';
import layoutExample2 from './assets/images/layout-example2.png';
import layoutExample3 from './assets/images/layout-example3.png';

const CSSLesson15 = () => {
  const [language, changeLanguage] = useState("css");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code = (
  'text',
  `
  h1  .hideElement {
    display: none;
  }
  `
  );
  const code1 = (
  'text',
  `
  li {
    display: inline;
  }
  `
  );
  const code2 = (
  'text',
  `
  h1  .hideElement {
    visibility: hidden;
  }
  `
  );



  return (
    <HTMLCourseNavProvider>
      <div className="container">
        <div className="row">
          <div>
            <SideBar />
          </div>
          <h3><strong>The display Property</strong></h3>
     <p>The display property is the most important CSS property for controlling layout.</p>
     <p>It specifies if/how an element should be displayed.</p>
     <p>Every HTML element has a default display value depending on what type of element it is. The default display value for most elements is block or inline.</p><br/>
      
     <h3>Block-level Elements</h3>
     <p>A block-level element always starts on a new line and takes up the full width available (stretches out to the left and right as far as it can).</p>
     <div className="alert alert-secondary" role="alert">

     <h4>Example</h4>
     <ul class="list-group list-group-horizontal">
      <li class="list-group-item">&lt;div&gt;</li>
      <li class="list-group-item">&lt;h1&gt;-&lt;h6&gt;</li>
      <li class="list-group-item">&lt;p&gt;</li>
    </ul>
    </div>

    <br/>
    
    <h3><strong>Inline Elements</strong></h3>
      <p>An inline element does not start on a new line and only takes up as much width as necessary.</p>
      <div className="alert alert-secondary" role="alert">
      <h4>Example</h4>
     <ul class="list-group list-group-horizontal mb-4">
      <li class="list-group-item">&lt;span&gt;</li>
      <li class="list-group-item">&lt;h6&gt;-&lt;h6&gt;</li>
      <li class="list-group-item">&lt;b&gt;</li>
    </ul>
    </div>
    <br/>
     
    <div className="alert alert-secondary" role="alert">
    <h3><strong>Display:none</strong></h3>
    <p><b>display: none</b> is commonly used with JavaScript to hide and show elements without deleting and recreating them. Please take a look at our Javascript course, we have talked extensively on the subject.</p>
    <p>When this feature is used, the element will be hidden, and the page will be displayed as if the element is not there.</p>


    <CopyBlock
    language={"css"}
    text={code}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>
     
    <div className="alert alert-secondary" role="alert">
      <h3><strong>Override default display</strong></h3>
    <p>Since every element has a default display value, we can, however, override this feature</p>
    <p>A common example is making inline <b class="text-danger">&lt;li&gt;</b> elements for horizontal menus:</p>

    <CopyBlock
    language={"css"}
    text={code1}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />


    </div>
    
    <div className="alert alert-secondary" role="alert">
    <h3><strong>display:none vs visibility:hidden</strong></h3>
       <p>Hiding an element can be done by setting the <b class="text-danger">display</b> property to <b class="text-danger">none</b>. The element will be hidden, and the page will be displayed as if the element is not there</p>
       <p><b class="text-danger">visibility:hidden;</b> will also hide an element, however, the element will still take up the same space as before. The element will be hidden, but still affect the layout</p>
     
       <CopyBlock
    language={"css"}
    text={code2}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />


     </div>


          </div>
        </div>
    </HTMLCourseNavProvider>
  );
};

export default CSSLesson15;
